import { render, staticRenderFns } from "./news13.vue?vue&type=template&id=5e40063c&scoped=true&"
import script from "./news13.vue?vue&type=script&lang=js&"
export * from "./news13.vue?vue&type=script&lang=js&"
import style0 from "./news13.vue?vue&type=style&index=0&id=5e40063c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e40063c",
  null
  
)

export default component.exports